<div class="rs-wrapper-v4">
    <h3 clas>También puede interesarte:</h3>
    <p>Vender {{system1.attributes.alternative_name}}:</p>
    <app-help-card-slide [helpCenterModel]="cardsSend"></app-help-card-slide>
    <p>Comprar {{system2.attributes.alternative_name}}:</p>
    <app-help-card-slide [helpCenterModel]="cardsReceive"></app-help-card-slide>
</div>
